import React, { useEffect, useState } from "react";
import { Input, InputLabel } from "@mui/material";
import "../UpdateUser/update-user.css";
import { useSelector } from "react-redux";
import { State, City } from "country-state-city";
import {
  updateCommunityApi,
  fetchCommunityDocName,
} from "../../Services/Community/CommunityAPI/communityApi";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CircularProgress } from "@mui/material"; // For MUI Loader



function UpdateUser() {
  const location = useLocation();
  const { profileData } = location.state || {};
 
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector(
    (state) => state.fetchProfileData?.data?.data
  );
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const status = userDetails?.status; // Extract status
 
 
  useEffect(() => {
    if (status === "deactivated") {
    

      localStorage.removeItem("access_token");
      localStorage.removeItem("accessToken");
    }
  }, [status]);


  useEffect(() => {
    dispatch(fetchCommunityDocName());
  }, [dispatch]);

  // State for form inputs
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    state: "",
    position: "",
    phone_number: "",
    location:""
  });

  useEffect(() => {
    const usaStates = State.getStatesOfCountry("US");
    setStates(usaStates);
    if (profileData) {
        const selectedState = usaStates?.find((state) => state.name === profileData.state);
        const stateCities = City.getCitiesOfState("US", selectedState?.isoCode);
        setCities(stateCities)
      setFormData({
        first_name: profileData?.first_name,
        last_name: profileData?.last_name,
        email: profileData?.email,
        state: profileData?.state,
        location: profileData?.location,
        phone_number: profileData?.phone_number,
        position:profileData?.position
      });

    }
  }, [profileData]);

  const userId = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");

 

  const handleStateChange = (e) => {
  
    const selectedStateName = e.target.value;
    const selectedState = states.find((state) => state.name === selectedStateName);

    setFormData((prevData) => ({
      ...prevData,
      state: selectedStateName, // Store state name for submission
     // Reset city on state change
    }));

    if (selectedState) {
      const stateCities = City.getCitiesOfState("US", selectedState.isoCode);
      setCities(stateCities);
    }

    // Clear validation error for state and city
    setErrors((prevErrors) => ({
      ...prevErrors,
      state: "",
    
    }));
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCity,
    }));

    // Clear validation error for city
    setErrors((prevErrors) => ({
      ...prevErrors,
      city: "",
    }));
  };

  // const handleTypeChange = (e) => {
  //   const selectedGender = e.target.value;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     gender: selectedGender, // Update gender in form data
  //   }));

    // Clear validation error for gender
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     gender: "",
  //   }));
  // };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;
  
    if (name === "email") {
      // Allow only letters, numbers, '@', and '.'
      // sanitizedValue = value.replace(/[^A-Za-z0-9@.]/g, "");
     sanitizedValue = value
  .replace(/[^A-Za-z0-9@._%+-]/g, "") // allow more valid email chars
  .replace(/\s+/g, "");               // remove spaces
     
    } else if (name === "phone_number") {
      //  Allow only numbers & limit to 10 digits
      sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "location") {
      //  Allow letters, numbers, and commas
      sanitizedValue = value.replace(/[^A-Za-z0-9, ]/g, "");
    }else if (name === "position") {
      //  Allow letters, numbers, and commas
      sanitizedValue = value.replace(/[^A-Za-z0-9.]/g, "");
      sanitizedValue = sanitizedValue.charAt(0).toUpperCase() + sanitizedValue.slice(1);
    }
    else {
        // Default: Allow only alphabets, spaces, hyphens, and underscores (no special characters)
    sanitizedValue = value.replace(/[^A-Za-z\-_ ]/g, "");

    // Capitalize first letter & keep remaining lowercase
    // sanitizedValue =
    //   sanitizedValue.charAt(0).toUpperCase() + sanitizedValue.slice(1).toLowerCase();
      sanitizedValue = sanitizedValue
  ?.split('-')
  .map(word => word?.charAt(0).toUpperCase() + word?.slice(1))
  ?.join('-');

    }
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  
    // ✅ Clear validation error for the current input
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const validateForm = () => {
    const errors = {};
    const nameRegex = /^[A-Za-z\s]+$/; // Allows only letters and spaces


      if (!formData.first_name) {
      errors.first_name = "First Name is required";
    } else if (!nameRegex.test(formData.first_name)) {
      errors.first_name = "First Name should only contain letters";
    }
    
    if (!formData.last_name) {
      errors.last_name = "Last Name is required";
    } else if (!nameRegex.test(formData.last_name)) {
      errors.last_name = "Last Name should only contain letters";
    }


    if (!formData.state) {
      errors.state = "State is required";
    }
    
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    
    if (!formData.position) {
      errors.position = "Position is required";
    }
  
    if (!formData.location) {
      errors.location = "Location is required";
    }

    if (!formData.phone_number || !/^\d{10}$/.test(formData.phone_number)) {
      errors.phone_number = "Phone Number must be exactly 10 digits";
    }
    
    setErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const isValid = validateForm();
   
    if (!isValid) {
      return;
    }

    const formDataToSubmit = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone_number,
      location: formData.location,
      state: formData.state,
      position: formData.position,
    };
    setLoading(true); // Loader start
    dispatch(updateCommunityApi({ formData: formDataToSubmit, id: profileData?.id }))
      .unwrap()
      .then((res) => {
        toast.success("User updated successfully!");

        setTimeout(() => {
          navigate("/user/user-profile");
        }, 2000);
     
        // if (user_type === SuperAdmin) {
        //   setTimeout(() => {
        //     navigate("/super-admin/super-admin-community-comp");
        //   }, 1000);
        // }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // remove first loader 
        toast.error("Failed to update User. Please try again.");
      });
  };


if (loading)
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "750px" }}>
      <CircularProgress color="primary"  size={60} /> {/* MUI Loader */}
    </div>
  );

  return (
    <>
    <div className="edit-section">
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section m-5 mt-3">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center mb-4">
            <div className="community-heading create-new"></div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <form className="create-community-form">
                {/* First Name */}
                <div className="main-community-block">
                  <div className="d-flex align-items-center community-city-blk">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">First Name</InputLabel>
                      <Input
                        id="first_name"
                        className="input-box"
                        placeholder="Enter First Name"
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                      />
                      {errors.first_name && (
                        <div className="error-text">{errors.first_name}</div>
                      )}
                    </div>

                    {/* Last Name */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">Last Name</InputLabel>
                      <Input
                        id="last_name"
                        className="input-box"
                        placeholder="Enter Last Name"
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                      />
                      {errors.last_name && (
                        <div className="error-text">{errors.last_name}</div>
                      )}
                    </div>

                    {/* Gender */}
                    <div className="comm-name-blk">
                    <InputLabel htmlFor="position">Position</InputLabel>
                       <Input
                        id="position"
                        className="input-box"
                        placeholder="Enter  Position"
                        type="text"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                      />
                      {errors.position && (
                        <div className="error-text">{errors.position}</div>
                      )}

                    </div>
                  </div>

                  <div className="gap-4 mb-4 state-type-unit-blk d-flex align-items-center">
                    {/* Email */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">Email</InputLabel>
                      <Input
                        id="email"
                        className="input-box"
                        placeholder="Enter Email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </div>

                    {/* Phone */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="unit">Phone</InputLabel>
                      <Input
                        id="phone_number"
                        className="input-box"
                        placeholder="Enter Phone Number"
                        type="number"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleInputChange}
                      />
                      {errors.phone_number && (
                        <div className="error-text">{errors.phone_number}</div>
                      )}
                    </div>
                  </div>

                  <div className="gap-4 mb-4 state-type-unit-blk d-flex align-items-center">
                    {/* State */}
                    <div className="city-name-blk">
                      <InputLabel htmlFor="state">State</InputLabel>
                      <select
                        id="state"
                        name="state"
                        className="dropdown-box"
                        value={formData.state}
                        onChange={handleStateChange}
                      >
                        <option value="" disabled>
                          Select state
                        </option>
                        {states?.map((state) => (
                          <option key={state.id} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <div className="error-text">{errors.state}</div>
                      )}
                    </div>

                    {/* City */}
                    <div className="city-name-blk">
                      <div className="mb-6">
                        <InputLabel htmlFor="location">
                        Location<span>*</span>
                        </InputLabel>
                        <Input
                        id="location"
                        className="input-box"
                        placeholder="Enter  Location"
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                      />
                        {errors.location && (
                          <div className="error-text">{errors.location}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="create-comm-btn">
              <button type="submit" className="blue-filled-btn" onClick={handleSubmit}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
     
      <ToastContainer />
    </>
  );
}

export default UpdateUser;
